module.exports = __webpack_public_path__ + "img/guide05.fa6dca0e.png";